import React from 'react';
import { WrappedComponentProps, injectIntl, useIntl } from 'react-intl';
/*models*/
import { IOrderHub } from '../../../../models/order';
import { IOrderStatuses } from '../../../../models/order-statuses';
import * as CON from '../../../common/constants';

/*CSS*/
import './order-tracker-styles.css';

interface ICategoryProps {
    state: IOrderStatuses;
    chevCatClass: (category: string) => string;
    warningDisplay: (category: string) => boolean;
    setPTagStyle: (category: string) => string;
    exceptionCheck: (category: string) => boolean;
    changeCategory: (category: string) => void;
    viewButtonCheck: (category: string) => boolean;
    currentEvent: IOrderHub;
    cancelled: boolean;
}

export const ShippingCategory = ({
    state,
    chevCatClass,
    warningDisplay,
    setPTagStyle,
    exceptionCheck,
    changeCategory,
    viewButtonCheck,
    currentEvent,
    cancelled,
}: ICategoryProps) => {
    const intl = useIntl();
    return (
        <div
            className={chevCatClass(CON.SHIPPING)}
            id={state.shipping.isActive ? 'shipping-active' : 'shipping'}
        >
            <div className="reRotate">
                {state.shipping.isCompleted && (
                    <>
                        <i className="check-mark fas fa-check-circle fa-lg"></i>
                        <div className="my-secret-div so"></div>
                    </>
                )}
                {warningDisplay(CON.SHIPPING) && (
                    <>
                        <i className="exclamation-1 fas fa-exclamation-circle fa-lg"></i>
                        <div className="my-secret-div"></div>
                    </>
                )}
                <p className={setPTagStyle(CON.SHIPPING)}>
                    {intl.formatMessage({
                        id: CON.SHIPPING,
                        defaultMessage: CON.SHIPPING,
                    })}
                </p>

                <div className="completed-div">
                    {state.shipping.isCompleted && !cancelled && (
                        <p
                            className={
                                !state.shipping.isActive
                                    ? 'p-no-margin blue'
                                    : 'p-no-margin'
                            }
                        >
                            {intl.formatMessage({
                                id: CON.COMPLETED,
                                defaultMessage: CON.COMPLETED,
                            })}
                        </p>
                    )}
                    {currentEvent.eventCatagory === CON.SHIPPING &&
                        currentEvent.exceptionLevel === '' &&
                        !cancelled && (
                            <p
                                className={
                                    !state.shipping.isActive
                                        ? 'p-no-margin blue'
                                        : 'p-no-margin'
                                }
                            >
                                {intl.formatMessage({
                                    id: CON.IN_PROGRESS_ID,
                                    defaultMessage: CON.IN_PROGRESS,
                                })}
                            </p>
                        )}

                    {exceptionCheck(CON.SHIPPING) && (
                        <p
                            className={
                                state.shipping.exception1
                                    ? 'p-no-margin exception-1'
                                    : 'p-no-margin exception-2'
                            }
                        >
                            {intl.formatMessage({
                                id: CON.EXCEPTION,
                                defaultMessage: CON.EXCEPTION,
                            })}
                        </p>
                    )}
                    {currentEvent.eventCatagory === CON.SHIPPING &&
                        cancelled && (
                            <p className="p-no-margin exception-2">
                                {intl.formatMessage({
                                    id: CON.CANCELLED,
                                    defaultMessage: CON.CANCELLED,
                                })}
                            </p>
                        )}
                    {viewButtonCheck(CON.SHIPPING) && (
                        <button
                            className="delete-items-pad-left"
                            id="view-details-btn-shipping"
                            onClick={() => {
                                changeCategory(CON.SHIPPING);
                            }}
                        >
                            {intl.formatMessage({
                                id: CON.VIEW_DETAIL_ID,
                                defaultMessage: CON.VIEW_DETAIL,
                            })}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ShippingCategory;
